import { useState } from 'react';
import { Link, useParams } from 'react-router';
import { authService } from '../../lib/api-service';
import logoImage from '@/imports/AlbaIuliaCTRo_logo.svg';
import { CheckCircle2 } from 'lucide-react';

export default function ResetPassword() {
  const { uid, token } = useParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Parolele nu coincid.');
      return;
    }

    if (!uid || !token) {
      setError('Link invalid.');
      return;
    }

    setSubmitting(true);
    try {
      await authService.confirmPasswordReset(uid, token, newPassword);
      setSuccess(true);
    } catch {
      setError('Link-ul a expirat sau parola nu îndeplinește cerințele (minim 8 caractere, o literă mare, o literă mică, o cifră).');
    } finally {
      setSubmitting(false);
    }
  }

  const inputClass =
    'w-full rounded-lg border px-3 py-2.5 text-sm outline-none transition-colors focus:border-[var(--vivid-purple)] focus:ring-2 focus:ring-[var(--vivid-purple)]/20';

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f8f8fa] px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <img src={logoImage} alt="CTRo 2026" className="mx-auto mb-6 h-12" />
          <h1
            className="text-2xl font-bold text-[var(--vivid-purple)]"
            style={{ fontFamily: 'var(--font-primary)' }}
          >
            Parolă nouă
          </h1>
        </div>

        <div className="rounded-2xl border bg-white p-6 shadow-sm">
          {success ? (
            <div className="text-center">
              <CheckCircle2 className="mx-auto mb-4 h-10 w-10 text-green-500" />
              <p className="mb-2 text-sm font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>
                Parola a fost resetată
              </p>
              <p className="mb-4 text-sm text-muted-foreground" style={{ fontFamily: 'var(--font-secondary)' }}>
                Te poți autentifica cu noua parolă.
              </p>
              <Link
                to="/cont"
                className="inline-block rounded-lg bg-[var(--vivid-purple)] px-6 py-2.5 text-sm font-semibold text-white"
                style={{ fontFamily: 'var(--font-primary)' }}
              >
                Autentificare
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && (
                <div className="mb-4 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>
              )}

              <div className="mb-4">
                <label className="mb-1.5 block text-sm font-medium" style={{ fontFamily: 'var(--font-primary)' }}>
                  Parola nouă
                </label>
                <input
                  type="password"
                  required
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className={inputClass}
                  style={{ fontFamily: 'var(--font-secondary)' }}
                />
                <p className="mt-1 text-xs text-muted-foreground" style={{ fontFamily: 'var(--font-secondary)' }}>
                  Minim 8 caractere, o literă mare, o literă mică, o cifră.
                </p>
              </div>

              <div className="mb-6">
                <label className="mb-1.5 block text-sm font-medium" style={{ fontFamily: 'var(--font-primary)' }}>
                  Confirmă parola
                </label>
                <input
                  type="password"
                  required
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className={inputClass}
                  style={{ fontFamily: 'var(--font-secondary)' }}
                />
              </div>

              <button
                type="submit"
                disabled={submitting}
                className="w-full rounded-lg bg-[var(--vivid-purple)] py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[var(--vivid-purple)]/90 disabled:opacity-60"
                style={{ fontFamily: 'var(--font-primary)' }}
              >
                {submitting ? 'Se resetează...' : 'Setează parola nouă'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
